import { useCallback, useEffect } from 'react';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getAllGroups } from '../../services/groupService';
import { apiParamsState } from '../../storage/app';
import { allGroupsState, editingGroupState, updateGroupsState } from '../../storage/groups';
import useUpdateEffect from '../../hooks/useUpdateEffect';

function AllGroupsProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const setAllGroups = useSetRecoilState(allGroupsState);
  const updateGroups = useRecoilValue(updateGroupsState);
  const resetUpdateGroups = useResetRecoilState(updateGroupsState);
  const resetEditingGroup = useResetRecoilState(editingGroupState);

  const loadAllGroups = useCallback(async () => {
    const invalid = !apiParams?.clientId || !apiParams?.subClientId;
    if (invalid) return;

    const { allGroups, error } = await getAllGroups(apiParams.clientId, apiParams.subClientId);
    if (!error && allGroups) {
      setAllGroups(allGroups);
    } else {
      setAllGroups(undefined);
    }
  }, [apiParams?.clientId, apiParams?.subClientId, setAllGroups]);

  useEffect(() => {
    loadAllGroups();
  }, [apiParams?.clientId, apiParams?.subClientId, loadAllGroups]);

  useUpdateEffect(() => {
    if (!updateGroups) return;

    loadAllGroups().finally(() => {
      resetUpdateGroups();
      resetEditingGroup();
    });
  }, [updateGroups]);

  return null;
}

export default AllGroupsProvider;
